import footer from './footer.json'
import header from './header.json'
import newHeaderOrganic from './newHeaderOrganic.json'
import headerSidebar from './headerSidebar.json'
import languageSwitch from './languageSwitch.json'
import madeWithLove from './madeWithLove.json'
import socialIcons from './socialIcons.json'
import breadcrumb from './breadcrumb.json'
import signupModal from './signupModal.json'
import topStripe from './topStripe.json'
import menuOrganic from './menuOrganic.json'

export default {
  footer,
  header,
  newHeaderOrganic,
  headerSidebar,
  languageSwitch,
  madeWithLove,
  socialIcons,
  breadcrumb,
  signupModal,
  topStripe,
  menuOrganic,
}
